import styles from "./PackPrice.module.scss";
import cn from "classnames";
import { type AccountTypeEnum, HIDDEN_ACCOUNT_TYPES } from "../../../interfaces/Account";
import { PricingTypes } from "enums/licensing/pricingTypes";
import { usePackPriceContext } from "./PackPriceContext";

interface Props {
  price?: number;
  disabled?: boolean;
  accountTypeId: AccountTypeEnum;
  parentAccountTypeId: AccountTypeEnum | null;
  packPricingTypeId: number;
}

export const PackPrice = ({ price, packPricingTypeId, disabled, accountTypeId, parentAccountTypeId }: Props) => {
  const isPaid = packPricingTypeId === PricingTypes.Paid;
  const hidePackPricing = usePackPriceContext();

  const hidden =
    hidePackPricing ||
    (isPaid && !price) ||
    HIDDEN_ACCOUNT_TYPES.includes(accountTypeId) ||
    (parentAccountTypeId && HIDDEN_ACCOUNT_TYPES.includes(parentAccountTypeId)) ||
    packPricingTypeId === PricingTypes.Other;

  if (hidden) return null;

  return (
    <div className={cn(styles.container, { [styles.disabled]: disabled })}>
      <div className={styles.price}>
        ${isPaid ? price!.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
      </div>
      {isPaid && <div className={styles.description}>user/month</div>}
    </div>
  );
};
